export const interactiveDemoHotspotGql = `
hotspotEntry {
    ... on interactiveDemoHotspot_interactiveDemoHotspot_Entry {
        title
        interactiveDemoDescription
        interactiveDemoEyebrow
        interactiveDemoHeader
        tooltip:interactiveDemoTooltip
        interactiveDemoLink {
            url
            target
            text
            customText
            ariaLabel
        }
        interactiveDemoMedia {
            ... on videoUploads_Asset {
                videoUrl:url
                thumbnail:videoThumbnail {
                    ... on images_Asset {
                        image:relatedEntries {
                            srcset
                            srcWebp
                        }
                    }
                }
            }
            ... on images_Asset {
                image:relatedEntries {
                    srcset
                    srcWebp
                }
            }
            ... on videos_Asset {
                youtubePoster:url
                youtubeId:videoId
                youtubeDescription:videoDescription
            }
        }
    }
}`;
